import { defineComponent as _defineComponent } from 'vue'


interface IProps {
  text: string;
  bgColor: string;
 
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AtomLegend',
  props: {
    text: { type: String, required: true },
    bgColor: { type: String, required: true, default: '#ccffee' }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})